import { useCallback } from "react";
import { forEach } from "lodash";

import { useLocationContext } from "~/context/LocationContext";

import { UTM_VARIABLES } from "~/utilities/helpers";
import { getQueryParam } from "~/utilities/searchHelpers";
import { setLocalStorageItem } from "~/utilities/localStorageHelpers";

const useUtmParams = () => {
    const { location } = useLocationContext();
    const queryVariables = getQueryParam(location.search);

    const save = useCallback(() => {
        if (queryVariables instanceof URLSearchParams) {
            forEach(UTM_VARIABLES, (utm) => {
                if (queryVariables.has(utm)) {
                    setLocalStorageItem(utm, queryVariables.get(utm));
                }
            });
        }
    }, [queryVariables]);

    return { save };
};

export default useUtmParams;
